import {connect} from 'react-redux';
import {TaskTracker as Component} from './TaskTracker';

import {
  focusFirstTask,
  clearLastActions,
  incTempPoints,
  clearTempPoints,
  saveSnapshot,
} from '../../../../actions';

function mapStateToProps(state) {
  return {
    //Internal Tracker Props
    lastActions: state.notebook.lastActions,
    focusedPage: state.notebook.focusedPage,
    focusedTask: state.notebook.focusedTask,
    focusedTaskObj: state.notebook.focusedTaskObj,

    points: state.notebook.tempPoints,
    pipettes: state.pipette.pipettes,
    solutions: state.solution.solutions,
    blotPapers: state.blotPaper.blotPapers,
    tipBoxes: state.tipBox.tipBoxes,
    trash: state.trash,
    notebook: state.notebook,
    scene: state.scene,

    //For Undo function - snapshot of all state
    state: state,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    focusFirstTask: (data) => {
      dispatch(focusFirstTask(data))
    },
    clearLastActions: (data) => {
      dispatch(clearLastActions(data))
    },
    incTempPoints: (data) => {
      dispatch(incTempPoints(data))
    },
    clearTempPoints: (data) => {
      dispatch(clearTempPoints(data))
    },
    saveSnapshot: (data) => {
      dispatch(saveSnapshot(data))
    }
  };
}

export const TaskTracker = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
